// criterioOptimizacion.js — P3-9b. Decide si una foto EXISTENTE conviene
// reprocesar, con los números REALES medidos (dimensiones del original + peso del
// JPG resultante de pasarla por la tubería). Frontend-only → export ES (el build
// caza el mismatch CJS/ESM). Puro.
//
// Criterio (Miguel, 1-nov-2026): reprocesar si la foto está SOBREDIMENSIONADA
// (más de 1600×2000) O si el JPG resultante pesa AL MENOS 30% menos que el
// original. Si no cumple ninguna, se deja como está. El censo de la Fase A es una
// COTA; el 30% de verdad sale de reprocesar y medir (esto recibe ese número).

export const TECHO_W = 1600;
export const TECHO_H = 2000;
export const UMBRAL_AHORRO = 0.30; // 30% más liviana

export function estaSobredimensionada(ancho, alto) {
  return (Number(ancho) > TECHO_W) || (Number(alto) > TECHO_H);
}

// { ancho, alto, pesoOriginal, pesoNuevo } (pesos en bytes)
// → { reprocesar, motivo, ahorroPct, ahorroBytes }
// motivo: 'sobredimensionada' (gana si aplica) | 'mas-liviana' | 'no'.
// ahorroPct/ahorroBytes: 0 si no hay ahorro (o la nueva pesa más) — nunca negativo.
export function decidirReproceso({ ancho, alto, pesoOriginal, pesoNuevo } = {}) {
  const orig = Number(pesoOriginal) || 0;
  const nuevo = Number(pesoNuevo) || 0;
  const ahorroBytes = orig > 0 && nuevo > 0 ? Math.max(0, orig - nuevo) : 0;
  const ahorroPct = orig > 0 ? ahorroBytes / orig : 0;
  const sobre = estaSobredimensionada(ancho, alto);
  const masLiviana = orig > 0 && nuevo > 0 && nuevo <= orig * (1 - UMBRAL_AHORRO);
  let motivo = 'no';
  if (sobre) motivo = 'sobredimensionada';
  else if (masLiviana) motivo = 'mas-liviana';
  return { reprocesar: sobre || masLiviana, motivo, ahorroPct, ahorroBytes };
}
